var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-model"},[_c('div',{ref:"commentPrint",attrs:{"id":'commentPrint' + _vm.comment.random}},[_c('p',{staticClass:"comment-print text-center",staticStyle:{"font-size":"22px","font-weight":"900","padding":"18px","color":"black"}},[_vm._v(" "+_vm._s(_vm.comment.comment)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }